import { defineMessages } from 'react-intl-next';
export const spotlight = defineMessages({
	next: {
		id: 'experiment-nth-user-orientation.spotlight.next',
		defaultMessage: 'Next',
		description: 'Label on button to advance onboarding tour to next step.',
	},
	back: {
		id: 'experiment-nth-user-orientation.spotlight.back',
		defaultMessage: 'Back',
		description: 'Label on button to go back to previous onboarding tour step.',
	},
	done: {
		id: 'experiment-nth-user-orientation.spotlight.done',
		defaultMessage: 'Done',
		description: 'Label on button to complete onboarding tour.',
	},
	dismiss: {
		id: 'experiment-nth-user-orientation.spotlight.dismiss',
		defaultMessage: 'Dismiss Tour',
		description: 'Label on button to dismiss onboarding tour.',
	},
	progress: {
		id: 'experiment-nth-user-orientation.spotlight.progress',
		defaultMessage: '{step} of {steps}',
		description: 'Label to show which step in a tour the user is currently viewing.',
	},
});

// Editor 1/3
export const editorSpaceSpotlight = defineMessages({
	headline: {
		id: 'experiment-nth-user-orientation.editorSpaceSpotlight.headline',
		defaultMessage: 'Your space, your start',
		description: 'Headline on a pop-up message pointing to the personal space navigation item',
	},
	body: {
		id: 'experiment-nth-user-orientation.editorSpaceSpotlight.body',
		defaultMessage: 'This is your personal space. Create more to organize your team’s work.',
		description: 'Body on a pop-up message pointing to the personal space navigation item',
	},
});

// Editor 2/3
export const editorForYouSpotlight = defineMessages({
	headline: {
		id: 'experiment-nth-user-orientation.editorForYouSpotlight.headline',
		defaultMessage: 'Catch up on team activity here',
		description: 'Headline on a pop-up message pointing to the for you navigation item',
	},
	body: {
		id: 'experiment-nth-user-orientation.editorForYouSpotlight.body',
		defaultMessage: 'See recent pages, team updates, and quick links tailored for you.',
		description: 'Body on a pop-up message pointing to the for you navigation item',
	},
});

// Editor 3/3
export const editorBpqaSpotlight = defineMessages({
	headline: {
		id: 'experiment-nth-user-orientation.editorBpqaSpotlight.headline',
		defaultMessage: 'Now let’s create your first page!',
		description: 'Headline on a pop-up message pointing to the template suggestions',
	},
	body: {
		id: 'experiment-nth-user-orientation.editorBpqaSpotlight.body',
		defaultMessage: 'With a template, a page is a click away. Hover on one for a preview.',
		description: 'Body on a pop-up message pointing to the template suggestions',
	},
});

// Home 1/3
export const homeForYouSpotlight = defineMessages({
	headline: {
		id: 'experiment-nth-user-orientation.homeForYouSpotlight.headline',
		defaultMessage: 'Welcome to For You',
		description: 'Headline on a pop-up message pointing to the for you navigation item',
	},
	body: {
		id: 'experiment-nth-user-orientation.homeForYouSpotlight.body',
		defaultMessage: 'See your team’s latest updates, all in one place. No detective work required.',
		description: 'Body on a pop-up message pointing to the for you navigation item',
	},
});

// Home 2/3
export const homeSpaceSpotlight = defineMessages({
	headline: {
		id: 'experiment-nth-user-orientation.homeSpaceSpotlight.headline',
		defaultMessage: 'Find your content in spaces',
		description: 'Headline on a pop-up message pointing to the personal space navigation item',
	},
	body: {
		id: 'experiment-nth-user-orientation.homeSpaceSpotlight.body',
		defaultMessage: 'Keep one for yourself and make many more for every project, team, or idea.',
		description: 'Body on a pop-up message pointing to the personal space navigation item',
	},
});

// Home 3a/3
export const homeTemplateSpotlight = defineMessages({
	headline: {
		id: 'experiment-nth-user-orientation.homeTemplateSpotlight.headline',
		defaultMessage: 'You’re all set 🚀',
		description: 'Headline on a pop-up message pointing to a template card',
	},
	body: {
		id: 'experiment-nth-user-orientation.homeTemplateSpotlight.body',
		defaultMessage: 'Kick things off with a template, or select Create to start from scratch.',
		description: 'Body on a pop-up message pointing to a template card',
	},
});

// Home 3b/3
export const homeCreateSpotlight = defineMessages({
	headline: {
		id: 'experiment-nth-user-orientation.homeCreateSpotlight.headline',
		defaultMessage: 'Ready to create your first page?',
		description: 'Headline on a pop-up message pointing to the global create button',
	},
	body: {
		id: 'experiment-nth-user-orientation.homeCreateSpotlight.body',
		defaultMessage: 'Select Create to create your first page.',
		description: 'Body on a pop-up message pointing to the global create button',
	},
});
